import buttonVariables from './buttonVariables';

export default buttonVariables;
